<template>
    <div class="container">
        <div v-for="(chunk, index) in chunks"
             :key="index"
             class="v-row">
            <gh-testimonial-grid-item v-for="testimonial in chunk" :key="testimonial.id" :testimonial="testimonial"  :show-individule-button="showIndividuleButton"  class="v-testimonial" :quotes-color="quotesColor"/>
        </div>
    </div>
</template>

<script>
    import allTestimonials from '@/modules/testimonial/contents/testimonialsV2'
    import ghTestimonialGridItem from '@/modules/testimonial/components/TestimonialGridItem.vue'

    export default {
        name: 'testimonial-grid',

        components: {
            ghTestimonialGridItem
        },

        props: {
            testimonials: {
                type: Array
            },

            showIndividuleButton: {
                type: Boolean,
                default: true
            },

            quotesColor: {
                type: String
            }
        },

        computed: {
            chunks() {
                const items = this.testimonials || allTestimonials.filter(testimonial => testimonial.excerpt)

                return _.chunk(items, 3)
            }
        }
    }
</script>

<style lang="scss" scoped>
    %p-testimonial {
        margin-bottom: 2rem;
        padding-bottom: 2rem;
        border-bottom: 1px solid #DDDDDD;

        &:last-of-type {
            margin-bottom: 0;
            padding-bottom: 0;
            border-bottom: 0;
        }
    }

    .v-row,
    .v-testimonial{
        @extend %p-testimonial
    }

    @media screen and (min-width: '768px') {
        .v-row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 2.5rem;
            padding-bottom: 1rem;
            margin-left: -1.5rem;
            margin-right: -1.5rem;
        }

        .v-testimonial {
            width: 33%;
            flex-basis: 33%;
            margin: 0;
            padding: 0 1.5rem;
            border-bottom: 0;
        }
    }
</style>